import axios from "axios";

// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // We no longer convert the error to a string here so callers can inspect
    // error.response and handle the message themselves (e.g. login logic).
    // If needed, you can still log or transform the error for debugging.
    
    // example of custom handling (leave error object intact):
    switch (error.response?.status) {
      case 500:
        console.warn("Internal Server Error");
        break;
      case 401:
        // Session expired - clear storage and redirect
        localStorage.removeItem("authUser");
        localStorage.removeItem("token");
        window.location.href = "/auth-login";
        break;
      case 404:
        console.warn("Resource not found");
        break;
      default:
        break;
    }
    return Promise.reject(error);
  }
);

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from given url
   */
  get = (url, params) => {
    return axios.get(url, params);
  };

  /**
   * post given data to url
   */
  create = (url, data) => {
    return axios.post(url, data);
  };

  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.put(url, data);
  };

  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}

const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };
